import { TimelineMax, Power3 } from 'gsap';
import routesOut from './routes/out';

const MenuOpen = () => {
  const background = document.querySelector('.menu__background');
  const firstLine = document.querySelector('.menu-icon__line:nth-child(1)');
  const lastLine = document.querySelector('.menu-icon__line:nth-child(3)');
  const menuVoices = Array.from(document.querySelectorAll('.menu-label'));
  const menuVoicesContainer = document.querySelector('.menu-voices');
  const menuContentVoices = Array.from(document.querySelectorAll('.menu-content-label'));
  const language = document.querySelector('.language-switch');
  const socials = document.querySelector('.socials');
  const contentBackground = document.querySelector('.menu-content__background');
  const close = document.querySelector('.menu-content__close');
  const outElements = Array.from(document.querySelectorAll('[data-in-out]:not([data-in-out-no-menu])'));
  const lines = Array.from(document.querySelectorAll('.menu-content__voices-line'));

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('before-start');
  outElements.forEach((outElement) => {
    tl.add(routesOut.get(outElement.dataset.inOutAnimation)(outElement), 'before-start');
  });
  tl.addLabel('start')
    .to(background, 0.6, {
      yPercent: 0,
      ease: Power3.easeInOut,
    }, 'start')
    .to(firstLine, 0.6, {
      scaleX: 0,
      transformOrigin: '0% 50%',
    }, 'start')
    .to(lastLine, 0.6, {
      scaleX: 0,
      transformOrigin: '100% 0%',
    }, 'start')
    .staggerTo(menuVoices, 0.6, {
      yPercent: -100,
      autoAlpha: 0,
      ease: Power3.easeInOut,
    }, 0.05, 'start')
    .set(menuVoicesContainer, { autoAlpha: 0 })
    .addLabel('half', '-=0.3')
    .staggerTo([close, ...menuContentVoices], 0.6, {
      yPercent: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 0.05, 'half')
    .to(language, 0.6, {
      yPercent: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'half')
    .to(socials, 0.6, {
      yPercent: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'half')
    .to(contentBackground, 0.6, {
      clipPath: 'inset(0% 0.001% 0.002% 0.003%)',
      webkitClipPath: 'inset(0% 0.001% 0.002% 0.003%)',
      ease: Power3.easeInOut,
    }, 'half')
    .to(lines, 0.6, {
      scaleX: 1,
      transformOrigin: '0px 50%',
      ease: Power3.easeInOut,
    }, 'half+=0.6');
  return tl;
};

export default MenuOpen;
